import { useNavigate } from 'react-router-dom';

export function Api_op() {
  const navigate = useNavigate();

  const platforms = [
    {
      name: 'Youtube Playlists',
      path: '/Backend_Api_Yt',
      imgSrc: 'https://thumbs.dreamstime.com/b/high-resolution-colored-youtube-logo-white-background-vector-eps-file-available-additional-download-colored-youtube-logo-175730434.jpg',
    },
    {
      name: 'Coursera',
      path: '/Backend_Api_Coursera',
      imgSrc: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmVgLGfhr0DKM1D4bBSvZh9h6UdIG84qhbSsHAsn_P1KeOEa_wGqqbO9z1zcyn3atADVU&usqp=CAU',
    },
    {
      name: 'Udemy Courses',
      path: '/Backend_Api_Udemy',
      imgSrc: 'https://logowik.com/content/uploads/images/udemy-new-20212512.jpg',
    },
    {
      name: 'Geeks For Geeks',
      path: '/Backend_Api_Gfg',
      imgSrc: 'https://miro.medium.com/v2/resize:fit:799/0*yxCtOgS-v50Sqfzw.jpeg',
    },
    {
      name: 'Coding Platforms',
      path: '/Backend_Api_Codplat',
      imgSrc: 'https://img.freepik.com/premium-vector/continuous-line-building-city-logo-design_15473-14266.jpg?semt=ais_hybrid',
    },
  ];

  return (
    <>
      <h1 className="html_head"> Links are below </h1>
      <p className="html_para">
        These are the platforms for your <strong>API</strong> Study purpose. Utilize this and these are the recommended platforms to explore and gain knowledge for practice and do more, again this is not for any Promotions it is for the <strong>educational purpose</strong> to do more, explore all in a short time.
      </p>
      <h3 className="reco_html"> Recommended Platforms </h3>

      {platforms.map((platform, index) => (
        <div key={index} className="container_html_pg">
          <img className="html_logo_yt" style={{ height: '90px', width: '90px' }} src={platform.imgSrc} alt={platform.name} />
          
          <h5 style={{ margin: '30px 0px 0px 30px', fontFamily: 'Arial', fontWeight: 'bold' }}>{platform.name} &#9754;</h5>
          <div className="butt_yt">
            <button className="btn_html_yt" onClick={() => navigate(platform.path)}>Click Me</button>
          </div>
        </div>
      ))}
    </>
  );
}

export default Api_op;
